import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Heading, Button, TextArea, Text } from '@components/common';
import { MobileContainer } from '@containers/layout';
import { DiscontinueSelectors } from '@redux/DiscontinueRedux';
import { SubscriptionSelectors } from '@redux/SubscriptionRedux';
import { trackSrvPaused, trackSrvDiscontinued } from '@services/analytics';
import { getErrors } from '@utils/error';
import DialogBox from '@components/DialogBox';
import CancelConfirm from '@containers/booking/Confirm/CancelConfirm';

import API from '@utils/api';

function DiscontinueConfirm(props) {
  const { onSubmit, isPause, discontinueDate, activeSubscription } = props;
  const [reason, setReason] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [show, toggleModal] = useState(false);
  const [isMoving, setIsMoving] = useState(false);

  const handleDissmisModal = () => {
    toggleModal(false);
    onSubmit();
  };

  const handleMovingRedirect = () => {
    toggleModal(false);
    onSubmit(false, isMoving);
  };
  const { recurringBookingID: recurringBookingId } = activeSubscription || {};
  const handleDiscontinue = async () => {
    try {
      if (isPause) {
        await API.pauseService(
          {
            resumeDate: discontinueDate
          },
          recurringBookingId
        );
        trackSrvPaused(activeSubscription, discontinueDate, reason);
        onSubmit(true);
      } else {
        await API.discontinueService({
          reason
        });
        trackSrvDiscontinued(activeSubscription, reason);
        setIsMoving(reason.toLowerCase().includes('mov') ? true : false);
        toggleModal(true);
      }
    } catch (err) {
      const error = getErrors(err);
      if (error.message) {
        setErrorMsg(error.message);
      } else {
        const firstMessage = Object.values(error).pop();
        setErrorMsg(
          firstMessage ||
            'There was error in processing the request. please try again'
        );
      }
    }
  };

  return (
    <MobileContainer>
      <Heading display={['none', 'block']} mb={4}>
        Your feedback
      </Heading>

      <TextArea
        height={['calc(79vh - 120px)', 443]}
        mb={4}
        value={reason}
        onChange={e => {
          setReason(e.target.value);
          setErrorMsg('');
        }}
        placeholder="Please let us know why you've decided to stop using The Minte."
      />
      <Text mb={4} color="red">
        {errorMsg}
      </Text>
      <Button
        width={1}
        mb={4}
        type="button"
        onClick={handleDiscontinue}
        disabled={!reason}
      >
        Done
      </Button>
      {!isMoving && (
        <DialogBox show={show} onClickOutside={handleDissmisModal}>
          <CancelConfirm
            cancelLabel="OK"
            title="Cancelation Successful"
            description="Please check your calendar for any remaining routine services."
            onCancel={handleDissmisModal}
          />
        </DialogBox>
      )}
      {isMoving && (
        <DialogBox show={show}>
          <CancelConfirm
            cancelLabel="Yes, I'm moving"
            submitLabel="No, I'll do it later"
            title="Cancelation Successful"
            description="Please check your calendar for any remaining routine services."
            optionalDescription="It looks like you're moving. Would you like to take The Minte with you?"
            onCancel={handleMovingRedirect}
            onSubmit={handleDissmisModal}
          />
        </DialogBox>
      )}
    </MobileContainer>
  );
}

DiscontinueConfirm.propTypes = {
  onSubmit: PropTypes.func,
  isPause: PropTypes.bool,
  discontinueDate: PropTypes.any,
  activeSubscription: PropTypes.any
};

const mapStatesToProps = state => ({
  isPause: DiscontinueSelectors.selectIsPause(state),
  discontinueDate: DiscontinueSelectors.selectDiscontinueDate(state),
  activeSubscription: SubscriptionSelectors.selectActiveSubscription(state)
});

export default connect(mapStatesToProps)(DiscontinueConfirm);
